/**
 * 账户充值记录列表页面路径
 */
export const RECHARGE_APPLY_LIST_PAGE_PATH = '/rechargeApply/list'

/**
 * 创建账户充值申请页面路径
 */
export const RECHARGE_APPLY_CREATE_PAGE_PATH = '/rechargeApply/create'

/**
 * 账户充值结果页面路径
 */
export const RECHARGE_APPLY_RESULT_PAGE_PATH = `/rechargeApply/result`
